// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3ocI2","item":"PaymentsMobile_item__sB0sb","label":"PaymentsMobile_label__2eZQf","amount":"PaymentsMobile_amount__Wo7Ni"};